module.exports = __webpack_public_path__ + "img/arrow.2dd1cc6a.svg";